import Icons from "../../assets/icons/icons.svg";

type IconProps = {
    name: string;
    className?: string;
    width?: number;
    height?: number;
    fill?: string;
};

const Icon = ({ name, className, width, height, fill }: IconProps) => {
    const iconName = `${Icons}#${name}`;
    return (
        <svg
            className={className}
            width={width}
            height={height ? height : width}
            fill={fill ?? "currentColor"}
            aria-hidden="true"
        >
            <use href={iconName} />
        </svg>
    );
};

export default Icon;
